module.exports = __webpack_public_path__ + "static/HKCompression-HeavyCondensed-b0a91cc2ec9854a0d4a24b70f57b27ca.woff";